import { render, staticRenderFns } from "./ViewMarketplaceBuyers.vue?vue&type=template&id=5f7f1bce&scoped=true&lang=true"
import script from "./ViewMarketplaceBuyers.vue?vue&type=script&lang=js"
export * from "./ViewMarketplaceBuyers.vue?vue&type=script&lang=js"
import style0 from "./ViewMarketplaceBuyers.vue?vue&type=style&index=0&id=5f7f1bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7f1bce",
  null
  
)

export default component.exports